export const GinVersion = '2.47.8';
export const GinBuild = '0000000004';
